<template>
  <div class="performanceDoingBox">
    <div class="notarizaSearch">
      <span class="fl">合同名称</span>
      <el-input v-model="notarizaName" placeholder="输入合同名称"></el-input>
      <span class="search">
        <img src="../../../../../assets/images/warning/search_icon_pre.png" @click="searchFn" />
      </span>
    </div>
    <el-table
      :data="listsTable"
      style="width: 100%;margin-bottom:10px;"
      border
      header-cell-class-name="cellCustomer headerCellCustomer ft14"
      cell-class-name="cellCustomer ft12"
    >
      <template slot="empty">
        <img class="data-pic" src="../../../../../assets/images/H5/null.png" alt />
        <br />暂无数据
      </template>
      <el-table-column prop="contractName" label="合同名称" width="230"></el-table-column>
      <el-table-column label="合同有效期" width="230">
        <template slot-scope="scope">{{scope.row.startDate}}&nbsp;至&nbsp;{{scope.row.endDate}}</template>
      </el-table-column>
      <el-table-column prop="signatoryList" label="签约方" width="150">
        <template slot-scope="scope">
          <span class="signatoryItem" v-for="item in scope.row.signatoryList" >{{item.name}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="taskName" label="当前任务阶段" width="150" ></el-table-column>
      <el-table-column label="当前任务状态" width="150">
        <template slot-scope="scope">
          <span
            class="signatoryItem"
            v-if="scope.row.perFormStatus==0&&scope.row.confirmStatus!==3"
          >未提交&nbsp;&nbsp;</span>
          <span
            class="signatoryItem"
            v-if="scope.row.perFormStatus==3||scope.row.confirmStatus==3"
          >已过期&nbsp;&nbsp;</span>
          <span
            v-if="scope.row.perFormStatus!=3&&scope.row.confirmStatus!=3&&scope.row.perFormStatus!=0"
          >
            <span class="signatoryItem">{{scope.row.perFormStatusName}}</span>
            <span class="signatoryItem">{{scope.row.confirmStatusName||''}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="190">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="listButton"
            @click="dealWith(scope.row.contractId)"
          >
            <img
              class="active"
              src="../../../../../assets/images/perfomance/details01_icon_hov_pre.png"
            />
            <img class="normal" src="../../../../../assets/images/perfomance/details_icon_nor.png" />
            <span class="buttonColor">任务列表</span>
          </el-button>
          <el-button
            type="text"
            size="small"
            class="listButton"
            @click="evidenceFn(scope.row.taskItemId)"
          >
            <img class="active" src="../../../../../assets/images/perfomance/group_9_copy.png" />
            <img class="normal" src="../../../../../assets/images/perfomance/group_9.png" />
            <span class="buttonColor">去处理</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <PageSize
      v-if="total"
      :currentPage="currentPage"
      :total="total"
      :pageSizes="pageSizes"
      :pageSize="pageSize"
      :page="'pages'"
      :size="'size'"
      class="pageDev"
    />-->
    <el-pagination
      style="float:right"
      @current-change="getMessage"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size.sync="pageSize"
      layout="sizes, prev, pager, next"
      :total="total"
      v-if="total>10"
    ></el-pagination>
  </div>
</template>
<script>
import PageSize from "@common/PageSize.vue";
import BaseApi from "@lib/baseApi.js";
import {mapState} from "vuex"
export default {
  data() {
    return {
      currentPage: 1, //默认第一页
      total: 0, //总条数
      pageSizes: [10, 20, 50, 100, 200], //每页展示多少条
      pageSize: 10, //默认第一页展示10条
      listsTable: [],
      notarizaName: "" //合同名称,
    };
  },
  methods: {
    getMessage() {
      var queryStr = {
        status: "0,1",
        contractName: this.notarizaName,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      if (this.notarizaName) queryStr.contractName = this.notarizaName;
      BaseApi.createRpcToken("/perform/performList", queryStr)
        .then(
          data => {
            if (data.datas) {
              this.listsTable = data.datas.result.list;
              this.total = data.datas.result.totalRow || 80;
              for (var i = 0; i < this.listsTable.length; i++) {
                if (this.listsTable[i].startDate != "") {
                  this.listsTable[i].startDate = this.listsTable[
                    i
                  ].startDate.split(" ")[0];
                }
                if (this.listsTable[i].endDate != "") {
                  this.listsTable[i].endDate = this.listsTable[i].endDate.split(
                    " "
                  )[0];
                }
              }
              console.log(data);
            } else {
              this.listsTable = [];
            }
          },
          data => {
            this.listsTable = [];
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    searchFn() {
      var this_1 = this;
      this_1.getMessage();
    },
    evidenceFn(id) {
      this.$router.push({
        path: "details",
        query: {
          id: id
        }
      });
    },
    dealWith(id) {
      this.$router.push({
        path: "mission",
        query: {
          id: id
        }
      });
    }
  },
  created() {
    this.getMessage();
  },
  components: {
    PageSize
  },
  computed:{
    ...mapState(['currentInfo']),
  },
   watch:{
    "currentInfo"(data){
       this.getMessage()
    }
  }
};
</script>
<style lang="scss">
.el-table__body, .el-table__footer, .el-table__header {
    table-layout: auto !important;
    border-collapse: separate;
}
.performanceDoingBox {
  height: 100%;
  width: 100%;
  .signatoryItem {
    padding: 0 10px 0 10px;
  }
  .listButton {
    .active {
      display: none;
    }
    .normal {
      display: inline-block;
      vertical-align: middle;
    }

    &:hover {
      .active {
        display: inline-block;
        vertical-align: middle;
      }
      .normal {
        display: none;
      }
      .buttonColor {
        color: red;
      }
    }
  }
  .notarizaSearch {
    width: 100%;
    margin-bottom: 20px;
    overflow: hidden;
    font-size: 14px;
    color: #646464;
    line-height: 30px;
    .el-input {
      height: 30px;
      margin-right: 10px;
      float: left;
      margin-left: 6px;
      .el-input__inner {
        height: 30px;
        line-height: 28px;
        border-radius: 0;
      }
      .el-input__icon {
        line-height: 28px;
      }
    }
    .el-input:nth-child(1),
    .el-input:nth-child(2) {
      width: 180px;
    }
    .el-input:nth-child(3) {
      width: 135px;
    }
    .el-select {
      float: left;
      .el-input {
        width: 107px;
      }
    }
    .search {
      width: 30px;
      height: 30px;
      float: left;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  table {
    width: 100% !important;
    // border-collapse: none;
    table-layout: auto;
    // th,
    // td {
    //   vertical-align: middle;
    //   height: 30px;
    //   padding: 0;
    // }
    // th:nth-child(1),
    // td:nth-child(1) {
    //   width: 26.1%;
    // }
    // th:nth-child(2),
    // td:nth-child(2) {
    //   width: 16.8%;
    // }
    // th:nth-child(3),
    // td:nth-child(3) {
    //   width: 17.6%;
    // }
    // th:nth-child(4),
    // td:nth-child(4) {
    //   width: 12%;
    // }
    // th:nth-child(5),
    // td:nth-child(5) {
    //   width: 10.8%;
    // }
    // th:nth-child(6),
    // td:nth-child(6) {
    //   width: 16.7%;
    // }
    // th {
    //   font-size: 14px;
    //   color: #505050;
    //   text-align: center;
    //   background: #f9f9f9;
    // }
    // td {
    //   font-size: 12px;
    //   color: #969696;
    //   text-align: center;
    //   img {
    //     vertical-align: middle;
    //     margin-right: 4px;
    //   }
    // }
    // .cell {
    //   text-align: center;
    //   line-height: 30px;
    //   padding: 0 !important;
    // }
    // .el-button {
    //   color: #919191;
    // }
    // .el-button + .el-button {
    //   margin-left: 20px;
    // }
  }
  .el-pagination {
    margin-top: 20px;
  }
  .cellCustomer {
    height: 32px;
    text-align: center;
    line-height: 32px;
    padding: 0;
    color: #969696;
    .el-button {
      color: #919191;
    }
  }
  .headerCellCustomer {
    color: #505050;
    background-color: #f9f9f9;
  }
}
</style>